import { createFileRoute } from '@tanstack/react-router';
import DocsGroupSectionLanding from '@/components/Docs/DocsGroupSectionLanding';

export const Route = createFileRoute('/docs/$section/')({
  component: DocsSectionLandingPage,
});

function DocsSectionLandingPage() {
  const { section } = Route.useParams();
  return <DocsGroupSectionLanding group="documentation" sectionSlug={section} />;
}
